import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useApp } from '../data/ColisContext';
import { BRAND } from '../data/constants';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useApp();
  const isMobile = typeof window !== 'undefined'
    ? window.matchMedia && window.matchMedia('(max-width: 640px)').matches
    : false;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [flash, setFlash] = useState('');

  useEffect(() => {
    const msg = location?.state?.flash;
    if (msg) {
      setFlash(String(msg));
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location?.state, location.pathname, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      const to = location?.state?.from?.pathname || '/dashboard';
      navigate(to, { replace: true });
    } catch (err) {
      setError(err?.message || 'Erreur de connexion');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'DM Sans', sans-serif", padding: isMobile ? '28px 14px' : '40px 20px' }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>
        <button onClick={() => navigate(-1)} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: '#4F46E5', fontWeight: 600, fontSize: 14,
          marginBottom: 18, display: 'flex', alignItems: 'center', gap: 6,
          fontFamily: 'inherit', padding: 0,
        }}>
          ← Retour
        </button>

        <div style={{ background: 'white', borderRadius: 20, padding: isMobile ? 18 : 28, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: 22, fontWeight: 900, color: '#1e293b', marginBottom: 6 }}>Connexion</div>
          <div style={{ fontSize: 14, color: '#64748b', marginBottom: 20 }}>Accède à ton espace pour déposer et suivre tes colis.</div>

          {flash && (
            <div style={{ background: '#DCFCE7', color: '#166534', padding: '10px 12px', borderRadius: 12, fontWeight: 800, fontSize: 13, marginBottom: 14 }}>
              {flash}
            </div>
          )}

          {error && (
            <div style={{ background: '#FEE2E2', color: '#B91C1C', padding: '10px 12px', borderRadius: 12, fontWeight: 700, fontSize: 13, marginBottom: 14 }}>
              {error}
            </div>
          )}

          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Email
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 700, fontSize: 13, color: '#334155' }}>
              Mot de passe
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <button type="submit" style={{ marginTop: 8, padding: '14px 16px', borderRadius: 14, border: 'none', cursor: 'pointer', fontWeight: 900, color: 'white', background: BRAND.gradient, boxShadow: '0 6px 20px rgba(79,70,229,0.25)', fontFamily: 'inherit' }}>
              Se connecter
            </button>
          </form>

          <div style={{ marginTop: 16, fontSize: 13, color: '#64748b' }}>
            Pas encore de compte ?{' '}
            <Link to="/register" style={{ color: BRAND.primary, fontWeight: 800, textDecoration: 'none' }}>Créer un compte</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
